import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatCurrency' })
export class FormatCurrencyPipe implements PipeTransform {
    transform(value: number | null | undefined): string {
        if (value == null) return '0 ₸';
        return new Intl.NumberFormat('ru-RU', {
            style: 'decimal',
            maximumFractionDigits: 0
        }).format(value) + ' ₸';
    }
}
